<template>
  <div v-if="original">
    <b-modal
      title="Achtung: unabgespeicherte Daten"
      v-model="modalCloseDialogueState"
      size="md"
      centered
      ><!-- modal -->
      <div>
        <p>
          Sie haben Änderungen vorgenommen, aber nicht abgespeichert. Sind Sie
          sich sicher, dass sie das Edit-Fenster schliessen wollen?
        </p>
      </div>
      <template #modal-footer>
	      <div class="w-100">
		      <b-button
				      size="md"
				      class="float-right mx-1"
				      variant="danger"
				      @click="modalCloseDialogue('confirm')"
		      >verwerfen</b-button
		      >
		      <b-button
				      size="md"
				      class="float-right"
				      @click="modalCloseDialogue('abort')"
		      >beibehalten</b-button
		      >
	      </div>
      </template>
    </b-modal>

    <b-modal
      title="Wirklich löschen?"
      v-model="modalNukeDialogueState"
      size="md"
      centered
      ><!-- modal -->
      <div>
        <p>Wollen Sie den bestehende Konfigurationseintrag wirklich löschen?</p>
      </div>
      <template #modal-footer>
	      <div class="w-100">
		      <b-button
				      size="md"
				      class="float-right mx-1"
				      variant="danger"
				      @click="nuke()"
		      >löschen</b-button
		      >
		      <b-button
				      size="md"
				      class="float-right"
				      @click="modalNukeDialogueState = false"
		      >beibehalten</b-button
		      >
	      </div>
      </template>
    </b-modal>

    <b-modal
      :title="mutant.id ? 'Config bearbeiten' : 'neue Config erstellen'"
      v-model="modalSuccessDialogue"
      centered
      ><!-- modal -->
      <div>
        <p>Die Konfiguration wurde erfolgreich abgespeichert.</p>
      </div>
      <template #modal-footer>
        <div class="w-100">
          <b-button
            size="md"
            class="float-right mx-1"
            variant="success"
            @click="
              visible = false;
              modalSuccessDialogue = false;
            "
            >schliessen</b-button
          >
        </div>
      </template>
    </b-modal>
    <b-modal title="Config bearbeiten" v-model="visible" size="xl"
      ><!-- modal -->
      <b-overlay
        id="overlay-background-dropdown"
        :show="queryInProgress"
        spinner-type="grow"
        rounded="lg"
        spinner-small
        ><!-- overlay -->
        <b-alert :show="configurationChanged" variant="warning"
          >Sie haben unabgespeicherte Änderungen offen.</b-alert
        >
        <br v-if="configurationChanged" />
        <div class="pr-3">
          <!-- the v-on thing doesn't work. But the crash prevents from the form from submitting. Oddly enough no events are being emitted on ENTER-keypress -->
          <b-form inline class="py-2" @submit="handleSubmit(evt)">
            <label class="mr-2 col-3 text-right">Gruppe:</label>
            <b-input
              :disabled="
                mutant.id !== null &&
                mutant.id !== undefined &&
                mutant.id !== ''
              "
              size="sm"
              class="mr-1 inputsf"
              v-model="mutant.configGroup"
            />
          </b-form>
          <b-form inline class="py-2" @submit="handleSubmit(evt)">
            <label class="mr-2 col-3 text-right">Label:</label>
            <b-input size="sm" class="mr-1 inputsf" v-model="mutant.label" />
          </b-form>
          <b-form inline class="py-2" @submit="handleSubmit(evt)">
            <label class="mr-2 col-3 text-right">Beschreibung:</label>
            <b-input
              size="sm"
              class="mr-1 inputsf"
              v-model="mutant.description"
            />
          </b-form>
          <b-form inline class="py-2" @submit="handleSubmit(evt)">
            <label class="mr-2 col-3 text-right">Key:</label>
            <b-input
              :disabled="
                mutant.id !== null &&
                mutant.id !== undefined &&
                mutant.id !== ''
              "
              size="sm"
              class="mr-1 inputsf"
              v-model="mutant.configKey"
            />
          </b-form>
          <b-form inline class="py-2" @submit="handleSubmit(evt)">
            <label class="mr-2 col-3 text-right">Wert:</label>
            <b-input
              size="sm"
              class="mr-1 inputsf"
              v-model="mutant.configValue"
            />
          </b-form>
          <b-form inline class="py-2" @submit="handleSubmit(evt)">
            <label class="mr-2 col-3 text-right">zulässige Werte:</label>
            <b-input
              size="sm"
              class="mr-1 inputsf"
              v-model="mutant.possibleValues"
            />
          </b-form>
          <b-form inline class="py-2" @submit="handleSubmit(evt)">
            <label class="mr-2 col-3 text-right">Änderungsgrund:</label>
            <b-input
              size="sm"
              class="mr-1 inputsf"
              v-model="mutant.lastUpdateReason"
            />
          </b-form>
        </div>
      </b-overlay>
      <template #modal-footer>
        <div class="w-100">
          <b-button
            :disabled="disableSaveButton()"
            size="md"
            class="float-right mx-1"
            variant="primary"
            @click="save()"
            ><!-- button -->
            <span>speichern</span>
          </b-button>
          <b-button
            :disabled="queryInProgress"
            size="md"
            class="float-right"
            @click="close()"
            ><!-- button -->
            <span v-if="configurationChanged">verwerfen</span>
            <span v-else>schliessen</span>
          </b-button>
          <b-button
            v-if="mutant.id"
            :disabled="queryInProgress"
            size="md"
            class="float-right mx-1"
            variant="danger"
            @click="openModalNukeDialogue()"
            ><!-- button -->
            <span>löschen</span>
          </b-button>
        </div>
      </template>
    </b-modal>
  </div>
</template>
<style>
.inputsf {
  min-width: 70% !important;
}
.modal-xl {
  max-width: auto !important;
  min-width: 92% !important;
}
</style>
<script>
export default {
  props: [],
  data() {
    return {
      /*configurationFields: [
				{ key: "configGroup", label: "Gruppe", sortable: true },
				{ key: "label", label: "Label", sortable: true },
				{ key: "description", label: "Beschreibung", sortable: true },
				{ key: "configKey", label: "Key", sortable: true },
				{ key: "configValue", label: "Wert", sortable: true },
				{ key: "possibleValues", label: "zulässige Werte", sortable: true },
				{ key: "lastUpdateReason", label: "Änderungsgrund", sortable: true }
			],*/
      configState: "mutant",
      visible: false,
      modalCloseDialogueState: false,
      modalNukeDialogueState: false,
      modalSuccessDialogue: false,
      queryInProgress: false,
      original: {
        id: "",
        configGroup: "",
        label: "",
        description: "",
        configKey: "",
        configValue: "",
        possibleValues: "",
        lastUpdateReason: "",
        lastUpdateUser: "",
        lastUpdateTime: "",
      },
      mutant: {
        id: "",
        configGroup: "",
        label: "",
        description: "",
        configKey: "",
        configValue: "",
        possibleValues: "",
        lastUpdateReason: "",
        lastUpdateUser: "",
        lastUpdateTime: "",
      },
    };
  },
  computed: {
    configurationChanged: function () {
      // if success dialogue is being shown, we just updated the config and there are no pending changes.
      if (this.modalSuccessDialogue) return false;
      // for(const key of Object.keys(this.original)) {
      //     if(this.mutant[key] !== this.original[key]){
      //         return true;
      //     }
      // }
      // return false;
      //WTF? Why isn't this working???
      return !_.isEqual(this.mutant, this.original);
    },
  },
  methods: {
    disableSaveButton() {
      return this.queryInProgress || !this.configurationChanged;
    },
    openModalNukeDialogue() {
      this.modalNukeDialogueState = true;
    },
    modalCloseDialogue(choice) {
      if ("confirm" === choice) {
        this.mutant = _.cloneDeep(this.original);
        this.visible = false;
      } else if ("abort" == choice) {
        //do nothing
      }
      this.modalCloseDialogueState = false;
    },
    handleSubmit(evt) {
      evt.preventDefault();
    },
    save() {
      if (this.configurationChanged) {
        this.queryInProgress = true;
        axios
          .post("/configuration/save", { payload: JSON.stringify(this.mutant) })
          .then((response) => {
            this.queryInProgress = false; //TODO maybe make SPA out of this, get rid of reload
            this.mutant = _.cloneDeep(response.data);
            this.modalSuccessDialogue = true;
            this.$emit(
              "mutant" == this.configState
                ? "mutatedConfiguration"
                : "createdNewConfiguration",
              response.data,
            );
          })
          .catch((error) => {
            this.queryInProgress = false;
            this.$bvToast.toast("Speichervorgang ist fehlgeschlagen.", {
              title: "Configuration Index",
              autoHideDelay: 32000,
              appendToast: false,
              variant: "danger",
            });
            console.error(error);
          });
      }
    },
    nuke() {
      axios
        .get(`/configuration/delete/${this.mutant.id}`)
        .then((response) => {
          this.$emit("deletedConfiguration", this.mutant.id);
          this.modalNukeDialogueState = false;
          this.visible = false;
        })
        .catch((error) => {
          alert("konnte Eintrag nicht löschen.");
          this.modalNukeDialogueState = false;
          console.error(error);
        });
    },
    open(configurationToBeEdited, configState = "mutant") {
      this.configState = configState;
      this.original = _.cloneDeep(configurationToBeEdited);
      this.mutant = _.cloneDeep(configurationToBeEdited);
      this.visible = true;
    },
    close() {
      if (this.configurationChanged) {
        this.modalCloseDialogueState = true;
      } else {
        this.visible = false;
      }
    },
  }
};
</script>
